import type { ExtractPropTypes } from 'vue'
import type _Drawer              from './drawer.vue'

import { drawerProps } from 'element-plus'

export const sdDrawerProps = {
    ...drawerProps,

    // 覆盖属性
    appendToBody  : { type: Boolean, default: true }, // 插入至 body 中
    destroyOnClose: { type: Boolean, default: true }, // 销毁内部元素

    // 扩展属性
    bodyLockScroll: { type: Boolean, default: false }, // 内容区域滚动锁定
} as const

export type SdDrawerProps    = ExtractPropTypes<typeof sdDrawerProps>
export type SdDrawerInstance = InstanceType<typeof _Drawer>


